import {
  AreaConfig,
  CountryConfig,
  DealConfig,
  RegionConfig,
  SectorConfig,
  SubSectorConfig,
  SubSubSectorConfig
} from './projectMasterData';

let mockResponse = {
  projectId: 0,
  targetSize: '0',
  targetName: '',
  projectStatus: 'Draft',
  quickLinks: [],
  toolIds: '',
  isStepFlag: 0
};
const findMatchingValues = (subSector: any, subSubSector: any) => {
  let matchingValues = SubSubSectorConfig.filter(
    (item) => item.sectorId === subSector && subSubSector.includes(item.id)
  );
  const concatenatedString = matchingValues.map((item) => item.content).join(', ');
  return concatenatedString;
};

export const projectDataConfig = (projectData: any, requestObjectFlag = true) => {
  let tempProjectData = { ...projectData };

  let tempArea = AreaConfig.find((area: any) => area.id === tempProjectData.area)?.content;
  let tempRegion = RegionConfig.find(
    (region: any) => region.areaId === tempProjectData.area && region.id === tempProjectData.region
  )?.content;
  let tempCountry = CountryConfig.find(
    (country: any) =>
      country.regionId === tempProjectData.region && country.id === tempProjectData.country
  )?.content;
  let tempSector = SectorConfig.find(
    (sector: any) => sector.id === tempProjectData.targetSector
  )?.content;
  let tempSubSector = SubSectorConfig.find(
    (sector: any) =>
      sector.sectorId === tempProjectData.targetSector && sector.id === tempProjectData.subSector
  )?.content;
  let tempSubSubSector = findMatchingValues(
    tempProjectData.subSector,
    tempProjectData.subSubSector
  );
  let tempDealSize = DealConfig.find((deal: any) => deal.id === tempProjectData.dealSize)?.content;

  tempProjectData.area = tempArea;
  tempProjectData.region = tempRegion;
  tempProjectData.country = tempCountry;
  tempProjectData.targetSector = tempSector;
  tempProjectData.subSector = tempSubSector;
  tempProjectData.subSubSector = tempSubSubSector;
  tempProjectData.dealSize = requestObjectFlag ? tempProjectData.dealSize : tempDealSize;

  return tempProjectData;
};

export const createRequestBody = (
  projectData: any,
  selectedTemplete: any,
  selctedMilestone: any,
  allMembers : any,
  selectedTemplateID: any
) => {
  let projectDataRequestBody = projectDataConfig(projectData);
  let requestObject = {
    ...projectDataRequestBody,
    templateJson: selectedTemplete,
    milestones: selctedMilestone,
    members: allMembers,
    templateId: selectedTemplateID,
    ...mockResponse
  };
  return requestObject;
};

const OldrequestObject = {
  projectId: 0,
  projectName: 'Sample',
  targetName: '',
  category: 'Internal project',
  targetSector: 'Automotive',
  paceId: '',
  targetSize: '0',
  clientName: '',
  engagementId: '',
  dealSize: 0,
  area: 'Asia-Pacific',
  country: 'Malaysia',
  description: 'Sample',
  projectStatus: 'Draft',
  region: 'ASEAN',
  subSector: 'Auto Components',
  subSubSector: 'Auto Parts & Equipment',
  templateId: 48,
  templateJson:
    '[{"key":0,"folder":"1. Client & Engagement Acceptance","subfolder":[{"key":0,"subFolder":"1.1. Internal Consultation Memos","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":1,"subFolder":"1.2. Discloser & Consent Letter or equivalent conflicts approvals","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":2,"subFolder":"1.3. Ring fencing memo","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":3,"subFolder":"1.4. Personal Independence Declaration","subSubfolder":[],"checked":true,"status":"Applicable"}],"checked":true,"status":"Applicable"},{"key":1,"folder":"2. Engagement Planning","subfolder":[{"key":0,"subFolder":"2.1. Fee Estimate","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":1,"subFolder":"2.2. Proposal approved by the client","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":2,"subFolder":"2.3. Planning Memo_Project Delivery Plan","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":3,"subFolder":"2.4. Risk Management Action Plan (RMAP)","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":4,"subFolder":"2.5. Approvals from GCSP, Independence, SL Quality, GCO, Conflicts etc.","subSubfolder":[],"checked":true,"status":"Applicable"}],"checked":true,"status":"Applicable"},{"key":2,"folder":"3. Contractual terms","subfolder":[{"key":0,"subFolder":"3.1. Engagement Agreement","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":1,"subFolder":"3.2. Master Service Agreement (MSA)","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":2,"subFolder":"3.3. Scope amendments","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":3,"subFolder":"3.4. Prime-sub memo (inter office memos)","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":4,"subFolder":"3.5. Confidentiality Agreement, NDAs or similar","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":5,"subFolder":"3.6. Third party access - Reliance or Duty of Care Letter","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":6,"subFolder":"3.7. Third party access - Non-Reliance or Release Letter","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":7,"subFolder":"3.8 Auditor Hold Harmless Letters","subSubfolder":[],"checked":false,"status":"Not applicable"},{"key":8,"subFolder":"3.9 Termination Letter","subSubfolder":[],"checked":false,"status":"Not applicable"}],"checked":false,"status":"Not applicable"},{"key":3,"folder":"4. Engagement controlling_Fee","subfolder":[{"key":0,"subFolder":"4.1. Budget actual analysis","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":1,"subFolder":"4.2. Fee discussions","subSubfolder":[],"checked":true,"status":"Applicable"}],"checked":true,"status":"Applicable"},{"key":4,"folder":"5. Information gathering_Notes_Working Papers","subfolder":[{"key":0,"subFolder":"5.1. Questions raised by client and answers provided re-Work Product","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":1,"subFolder":"5.2. Info received_meeting file notes - Target","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":2,"subFolder":"5.3. Info received_meeting file notes - Client","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":3,"subFolder":"5.4. Significant communications with third parties","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":4,"subFolder":"5.5. Other e.g. minutes, emails","subSubfolder":[],"checked":true,"status":"Applicable"}],"checked":true,"status":"Applicable"},{"key":5,"folder":"6. Reviews","subfolder":[{"key":0,"subFolder":"6.1. Review and Approval Summaries (RAS) or evidence of review","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":1,"subFolder":"6.2. Hot reviews incl. minutes and actions","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":2,"subFolder":"6.3. Second Partner Review and Insights","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":3,"subFolder":"6.4. Consultation with SL Quality team","subSubfolder":[],"checked":true,"status":"Applicable"}],"checked":true,"status":"Applicable"},{"key":6,"folder":"7. EY Analysis","subfolder":[{"key":0,"subFolder":"7.1. Draft Reports (incl. status updates)","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":1,"subFolder":"7.2. Final Reports","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":2,"subFolder":"7.3. Letters - Transmittal_Representation","subSubfolder":[],"checked":true,"status":"Applicable"}],"checked":true,"status":"Applicable"},{"key":7,"folder":"8. Engagement Closing","subfolder":[{"key":0,"subFolder":"8.1 Mercury and GFIS records such as final engagement economics and invoices","subSubfolder":[],"checked":true,"status":"Applicable"},{"key":1,"subFolder":"8.2 Client feedback_ESQ_ASQ","subSubfolder":[],"checked":true,"status":"Applicable"}],"checked":true,"status":"Applicable"}]',
  milestones: [
    {
      endTime: '1:00 PM',
      startDate: '2024-05-30T06:47:58.600Z',
      startTime: '12:30 PM',
      title: 'Sample-M1'
    }
  ],
  quickLinks: [],
  toolIds: '',
  members: [
    {
      type: 'members',
      userEmailId: 'dharanikumar.s@gds.ey.com',
      displayName: 'Dharanikumar S',
      objectId: '1ff1f3ea-7b13-48a0-87b3-fdac7e0bf544',
      profileImageUrl: ''
    },
    {
      type: 'coowner',
      userEmailId: 'Dharanikumar.S@gds.ey.com',
      displayName: 'Dharanikumar S',
      objectId: '1ff1f3ea-7b13-48a0-87b3-fdac7e0bf544',
      profileImageUrl: ''
    },
    {
      type: 'engagementPartner',
      userEmailId: 'Dharanikumar.S@gds.ey.com',
      displayName: 'Dharanikumar S',
      objectId: '1ff1f3ea-7b13-48a0-87b3-fdac7e0bf544',
      profileImageUrl: ''
    },
    {
      type: 'engagementManager',
      userEmailId: 'Dharanikumar.S@gds.ey.com',
      displayName: 'Dharanikumar S',
      objectId: '1ff1f3ea-7b13-48a0-87b3-fdac7e0bf544',
      profileImageUrl: ''
    }
  ],
  isConfidetnial: false,
  isStepFlag: 0
};
